exports.CLIENT_URL = "https://adas.transharyana.in"
exports.BASE_URL = "__HTTP_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__/server";
exports.SOCKET_URL = "__HTTP_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__";
exports.RTSP_BASE_URL = "__WS_PROTOCOL_PLACEHOLDER__://__HOST_DOMAIN_PLACEHOLDER__";

// exports.BASE_URL = "http://172.20.10.4:3001";
// exports.SOCKET_URL = "http://172.20.10.4:3001";
// exports.RTSP_BASE_URL = 'ws://172.20.10.4'

exports.API_ROUTES = {
  AUTH: {
    LOGIN: "/api/auth/login",
    LOGOUT: "/api/auth/logout",
    SESSION: "/api/auth/session",
    MAP_TOKEN: "/api/auth/map-token",
  },
  DASHBOARD: {
    WEATHER: "/api/dashboard/weather",
    LOCATIONS: "/api/dashboard/locations",
    GROUP_DEVICES: "/api/dashboard/devices/group",
    LOCATION_DEVICES: "/api/dashboard/devices/location",
    MASTER_DATA: "/api/dashboard/masters",
  },
  INCIDENTS: {
    REQ_REPONSE: "/api/incidents/response",
    INCIDENT_MASTER: "/api/incidents/incident-dropdown-details",
    RAISE_INCIDENT: "/api/incidents/raise-new-incident",
    UPLOAD_IMAGE: "/api/incidents/upload-incident-image",
    INCIDENT_DETAILS: "/api/incidents/all-incidents",
    RESOLVE_INCIDENT: "/api/incidents/resolve",
    RAISE_CHALLAN: "/api/incidents/generate-challan",
    REPORT_UPDATE: "/api/incidents/update-incident",
    RPO_INCIDENTS: "/api/incidents/rpo-incidents/",
    VIOLATIONS: "/api/incidents/incident-violation",
    ADD_VEHICLE: "/api/incidents/add-vehicle-details",
    SHOW_VEHICLE: "/api/incidents/show-vehicle-details",
    DELETE_VEHICLE: "/api/incidents/delete-vehicle-details",
    EDIT_VEHICLE: "/api/incidents/edit-vehicle-details",
    REPORT_INCIDENT: "/api/incidents/report-incident",
  },
};
